import ActionButton from '~components/atoms/ActionButton';
import Modal from '~components/atoms/Modal';
import Text from '~components/atoms/Text';
import combinedActions from '~redux/combinedActions';
import { useAppDispatch, useAppSelector } from '~redux/hooks';
import { TUpdateStockOutStatusReduxParams } from '~types/feat/approval';
import UtilFunctions from '~utils/functions';
import * as Styles from './_confirmUpdateStockOutStatusModal.module.scss';

const ConfirmUpdateStockOutStatusModal = () => {
    const dispatch = useAppDispatch();

    const isOpen = useAppSelector(state => state.approval.modals.confirmUpdateStockOutStatusModalIsOpen);
    const tempUpdateStockOutState = useAppSelector(state => state.approval.tempUpdateStockOutState);
    const isLoading = useAppSelector(state => state.approval.loadings.updateStockOutStatus);
    const error = useAppSelector(state => state.approval.errors.updateStockOutStatus);

    const getStatus = () => {
        switch (tempUpdateStockOutState.status) {
            case 2: return 'Approve';
            case 3: return 'Reject';
            default: return '';
        }
    };

    const setIsOpen = (open: boolean) =>
        dispatch(combinedActions.approvalSetConfirmUpdateStockOutStatusModalIsOpen(open));

    const updateStockOutStatus = (data: TUpdateStockOutStatusReduxParams) =>
        dispatch(combinedActions.approvalUpdateStockOutStatusAttempt(data));

    const handleSubmitClick = () => {
        updateStockOutStatus(tempUpdateStockOutState);
    };

    const confirmButtonStyles = UtilFunctions.Styles.concatClassNames([
        getStatus() === 'Approve' ? Styles['confirm-approve'] : '',
        getStatus() === 'Reject' ? Styles['confirm-reject'] : '',
    ]);

    const handleOnModalClose = () => {
        if (error) {
            dispatch(combinedActions.approvalResetUpdateStockOutStatusState());
        }
        setIsOpen(false);
    };

    return (
        <Modal
            isOpen={isOpen}
            onClose={handleOnModalClose}
            title={`Confirm ${getStatus()} Stock Out?`}
        >
            <div className={Styles['button-container']}>
                <ActionButton
                    label='Cancel'
                    onClick={handleOnModalClose}
                    className={Styles['cancel-button']}
                />
                <ActionButton
                    label={getStatus()}
                    onClick={handleSubmitClick}
                    isLoading={isLoading}
                    className={confirmButtonStyles}
                    disabled={isLoading}
                />
            </div>

            {error && (
                <Text
                    label={error}
                    isError
                />
            )}
        </Modal>
    );
};

export default ConfirmUpdateStockOutStatusModal;
